<template>
  <div>
    <b-input-group>
      <b-form-input v-model="newOption" placeholder="nazwa opcji" @keyup.enter="addOption(newOption)" />
      <b-button size="sm" variant="success" @click="addOption(newOption)"><i class="fa fa-plus"></i></b-button>
    </b-input-group>
  </div>
</template>
<script>

export default {
  props: [],
  data () {
    return {
      newOption: this.emptyOption()
    }
  },
  name: 'c-options-creator',
  methods: {
    emptyOption () {
      return ''
    },
    addOption (option) {
      this.$emit('option-added', option)
      this.newOption = this.emptyOption()
    }
  }
}
</script>
